import React from 'react'

interface BlockIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const BlockIcon: React.FC<BlockIconProps> = ({
  size = 18,
  color = '#292D32',
  className,
  onClick,
}) => (
    <svg 
        width={size} 
        height={size} 
        viewBox="0 0 19 19" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path 
            d="M9.5 17C13.64 17 17 13.64 17 9.5C17 5.36 13.64 2 9.5 2C5.36 2 2 5.36 2 9.5C2 13.64 5.36 17 9.5 17Z" 
            stroke={color} 
            strokeWidth="1.2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M14.675 4.25L4.17505 14.75" 
            stroke={color} 
            strokeWidth="1.2" 
            strokeMiterlimit="10" 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
  );

export default BlockIcon